const seesaw = (window.seesaw = {
  threshold: 0,
  seeElements: [],
  sawElements: [],
  stickyElements: [],
  motionElements: [],

  init: () => {
    //initialize/reset event listeners
    window.removeEventListener('resize', seesaw.scan);
    window.removeEventListener('scroll', seesaw.trigger);
    window.removeEventListener('touchmove', seesaw.trigger);
    window.removeEventListener('touchstart', seesaw.trigger);
    window.removeEventListener('touchend', seesaw.trigger);

    window.addEventListener('resize', seesaw.scan);
    window.addEventListener('scroll', seesaw.trigger);
    window.addEventListener('touchmove', seesaw.trigger);
    window.addEventListener('touchstart', seesaw.trigger);
    window.addEventListener('touchend', seesaw.trigger);

    //listen for dom changes
    var mutationObserver = new MutationObserver(seesaw.processNewElements);
    mutationObserver.observe(document.documentElement, {
      attributes: !1,
      characterData: !1,
      childList: !0,
      subtree: !0,
      attributeOldValue: !1,
      characterDataOldValue: !1,
    });
  },

  getMotionProperties: (motion) => {
    return motion
      .split(';')
      .filter(Boolean)
      .map(function (motionProperty) {
        var parts = motionProperty.split(':');
        var property = parts[0];
        var value = parseFloat(parts[1]);
        var unit = parts[1]
          .match(/[^\-0-9]/g)
          .join('')
          .trim();

        return {
          property: property,
          value: value,
          unit: unit,
        };
      });
  },

  scan: () => {
    seesaw.seeElements = [];
    seesaw.sawElements = [];
    seesaw.motionElements = [];

    document.querySelectorAll('[data-see]').forEach(function (node) {
      var layout = node.getBoundingClientRect();
      var yStart = layout.top + window.scrollY;
      var yEnd = yStart + layout.height;

      seesaw.seeElements.push({
        yStart: yStart,
        yEnd: yEnd,
        node: node,
      });
    });

    document.querySelectorAll('[data-saw]:not([data-saw=true]').forEach(function (node) {
      var layout = node.getBoundingClientRect();
      var yStart = layout.top + window.scrollY;
      var yEnd = yStart + layout.height;

      seesaw.sawElements.push({
        yStart: yStart,
        yEnd: yEnd,
        node: node,
      });
    });

    document.querySelectorAll('[data-stick-start]').forEach(function (node) {
      var layout = node.getBoundingClientRect();
      var stickStart = window.scrollY + layout.y - parseFloat(node.getAttribute('data-stick-start'));

      seesaw.stickyElements.push({
        stickStart: stickStart,
        stickStop: stickStart + parseInt(node.getAttribute('data-stick-stop')),
        node: node,
      });
    });

    document.querySelectorAll('[data-motion-start]').forEach(function (node) {
      var layout = node.getBoundingClientRect();
      var yStart = layout.top + window.scrollY;

      var startOffset = parseInt(node.getAttribute('data-motion-start-offset'));
      var endOffset = parseInt(node.getAttribute('data-motion-end-offset'));

      if (node.getAttribute('data-motion-start-offset') === 'height') {
        yStart += layout.height;
      } else if (startOffset) {
        yStart += startOffset;
      }

      var yEnd = yStart + layout.height;

      if (node.getAttribute('data-motion-end-offset') === 'height') {
        yEnd += layout.height;
      } else if (endOffset) {
        yEnd += endOffset;
      }

      var motionStart = getMotionProperties(node.getAttribute('data-motion-start'));
      var motionEnd = getMotionProperties(node.getAttribute('data-motion-end'));

      seesaw.motionElements.push({
        yStart: yStart,
        yEnd: yEnd,
        motion: {
          start: motionStart,
          end: motionEnd,
        },
        node: node,
      });
    });
  },

  trigger: () => {
    var viewportStart = window.scrollY * (1 + seesaw.threshold);
    var viewportEnd = (window.scrollY + window.innerHeight) * (1 - seesaw.threshold);

    seesaw.seeElements.forEach(function (element) {
      if (element.yStart <= viewportEnd && element.yEnd >= viewportStart) {
        element.node.setAttribute('data-see', 'true');
      } else {
        element.node.setAttribute('data-see', 'false');
      }
    });

    seesaw.sawElements.forEach(function (element, i) {
      if (element.yStart <= viewportEnd && element.yEnd >= viewportStart) {
        element.node.setAttribute('data-saw', 'true');
        delete seesaw.sawElements[i];
      }
    });

    seesaw.motionElements.forEach(function (element) {
      if (element.yStart <= viewportEnd && element.yEnd >= viewportStart) {
        var rangeStart = element.yStart - window.innerHeight;
        var rangeEnd = element.yEnd;
        var range = rangeEnd - rangeStart;
        var progress = (window.scrollY - rangeStart) / range;

        var motion = element.motion.start.map(function (start, i) {
          var end = element.motion.end[i];
          var value = start.value + (end.value - start.value) * progress;
          return start.property + '(' + value + start.unit + ')';
        });
        element.node.style.transform = motion.join(' ');
      }
    });

    seesaw.stickyElements.forEach(function (element) {
      if (element.stickStart > window.scrollY) {
        element.node.style.transform = 'translateY(0)';
      } else if (element.stickStop < window.scrollY) {
      } else if (element.stickStart <= window.scrollY) {
        element.node.style.transform = 'translateY(' + (window.scrollY - element.stickStart) + 'px)';
      }
    });
  },

  processNewElements: () => {
    seesaw.scan();
    seesaw.trigger();
  },
});

seesaw.init();
